<template>
  <div class="info-card">
    <div class="info-card-head">
      <span class="info-card-title">
        <v-icon small :color="brandColor" class="mr-1">credit_card</v-icon>
        Cheque Especial
      </span>
      <span class="od-status" :class="statusClass">{{ statusLabel }}</span>
    </div>

    <div v-if="loading" class="pa-3">
      <div class="info-skeleton mb-2"></div>
      <div class="info-skeleton mb-2"></div>
      <div class="info-skeleton"></div>
    </div>

    <div v-else-if="!hasLimit" class="info-card-body">
      <div class="od-empty">Nenhum limite de cheque especial disponível.</div>
    </div>

    <div v-else class="info-card-body">
      <div class="info-row">
        <span class="info-key">Limite</span>
        <span class="info-val">{{ money(overdraft.limit) }}</span>
      </div>
      <div class="info-row">
        <span class="info-key">Utilizado</span>
        <span class="info-val">{{ money(overdraft.used) }}</span>
      </div>
      <div class="info-row">
        <span class="info-key">Disponível</span>
        <span class="info-val od-available">{{ money(overdraft.available) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Flowit from "@/services/flowit";

export default {
  name: "Overdraft",
  data() {
    return { overdraft: null, loading: true };
  },
  created() {
    this.fetchOverdraft();
  },
  computed: {
    ...mapGetters({ color: "account/color" }),
    brandColor() {
      return this.color && String(this.color).startsWith("#") ? this.color : "#1976D2";
    },
    hasLimit() {
      return this.overdraft && this.overdraft.limit != null;
    },
    statusLabel() {
      const map = { enabled: "Ativo", waiting: "Em análise", desabled: "Inativo" };
      return (this.overdraft && map[this.overdraft.status]) || "—";
    },
    statusClass() {
      return this.overdraft && this.overdraft.status === "enabled" ? "od-on" : "od-off";
    },
  },
  methods: {
    money(value) {
      return this.$n(Number(value || 0), "currency");
    },
    fetchOverdraft() {
      this.loading = true;
      Flowit.wallet
        .getOverdraft()
        .then(response => {
          this.overdraft = response.data;
        })
        .catch(() => {
          this.overdraft = null;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.info-card {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 28px rgba(20, 30, 60, 0.08);
  height: 100%;
  overflow: hidden;
}
.info-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #eef1f6;
}
.info-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2733;
  display: inline-flex;
  align-items: center;
}
.od-status {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
}
.od-on {
  color: #1e7d34;
  background: #e5f5ea;
}
.od-off {
  color: #8a94a6;
  background: #eef1f6;
}
.info-card-body {
  padding: 8px 22px 16px;
}
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f4f6f9;
}
.info-row:last-child {
  border-bottom: 0;
}
.info-key {
  font-size: 13px;
  color: #8a94a6;
  font-weight: 600;
}
.info-val {
  font-size: 14px;
  color: #1f2733;
  font-weight: 600;
  text-align: right;
}
.od-available {
  color: #1e7d34;
}
.od-empty {
  font-size: 13px;
  color: #8a94a6;
  padding: 14px 0;
}
.info-skeleton {
  height: 16px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
